import { HttpService } from '@Services/api/httpService.ts';
import { useBoundStore } from '@Store/useBoundStore';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types';
import { identifyLogRocketUser } from '@Services/analytics/logrocket.service';
import { identifyGA4User, setGA4UserProperties } from '@Services/analytics/analytics.service';

export const handleUboFlowInitialData = async (uboId: string): Promise<void> => {
  const { setUboData, setIsUsFlow, setSecondaryCustomerId } = useBoundStore.getState();
  const setOnboardingIdentifier = useBoundStore.getState().onboardingSlice.setOnboardingIdentifier;

  setSecondaryCustomerId(uboId);
  const path = `v3/onboarding/secondary/${uboId}`;
  const { data } = await HttpService.get(path);
  setUboData(data);
  const isUsFlow = data.secondaryCustomerDetails.country
    ? data.secondaryCustomerDetails.country === 'US'
    : true;
  identifyLogRocketUser(uboId, {
    isUsFlow,
    primaryCustomerId: data.primaryCustomerDetails.customerId,
  });
  setIsUsFlow(
    data.secondaryCustomerDetails.country ? data.secondaryCustomerDetails.country === 'US' : true
  );

  setOnboardingIdentifier(OnboardingFlowIdentifier.UBO);
  identifyGA4User(uboId);
  setGA4UserProperties();
};
